import * as THREE from '../client/three'
import { CHUNK_DEPTH, CHUNK_HEIGHT, CHUNK_WIDTH, getVoxelIdx } from './chunks'

export class Location {
  constructor() {
    this._mod = false
    this._world = new THREE.Vector3()
    this._world._onChange(() => {
      if (this._mod) return
      this._voxel.dirty = true
      // this._voxelLocal.dirty = true
      this._chunk.dirty = true
    })
    this._voxel = new THREE.Vector3()
    this._voxel._onChange(() => {
      if (this._mod) return
      this._mod = true
      this._world.copy(this._voxel)
      this._mod = false
      this._world.dirty = false
      this._voxel.dirty = false
      // this._voxelLocal.dirty = true
      this._chunk.dirty = true
    })
    // this._voxelLocal = new THREE.Vector3()
    // this._voxelLocal._onChange(() => {
    //   if (this._mod) return
    //   console.error('Location: voxelLocal should not be modified directly')
    // })
    this._chunk = new THREE.Vector3()
    this._chunk._onChange(() => {
      if (this._mod) return
      console.error('Location: chunk should not be modified directly')
    })
  }

  get world() {
    return this._world
  }

  set world(value) {
    this._world.copy(value)
    this._voxel.dirty = true
    this._chunk.dirty = true
  }

  get voxel() {
    if (this._voxel.dirty) {
      this._mod = true
      this._voxel.set(Math.floor(this._world.x + 0.5), Math.floor(this._world.y), Math.floor(this._world.z + 0.5))
      this._mod = false
      this._voxel.dirty = false
    }
    return this._voxel
  }

  set voxel(value) {
    this._voxel.copy(value)
  }

  // get voxelLocal() {
  //   if (this._voxelLocal.dirty) {
  //     const chunk = this.chunk
  //     if (!chunk) return null
  //     const cx = Math.floor(this._world.x + 0.5)
  //     const cz = Math.floor(this._world.z + 0.5)
  //     const localX = cx - chunk.x * CHUNK_WIDTH
  //     const localY = Math.floor(this._world.y)
  //     const localZ = cz - chunk.z * CHUNK_DEPTH
  //     this._mod = true
  //     this._voxelLocal.set(localX, localY, localZ)
  //     this._mod = false
  //     this._voxelLocal.dirty = false
  //   }
  //   return this._voxelLocal
  // }

  move(dir) {
    this._voxel.add(dir.normal)
  }

  get chunk() {
    if (this._chunk.dirty) {
      const pos = this._world
      if (pos.y < 0 || pos.y >= CHUNK_HEIGHT) {
        return null
      }
      this._mod = true
      const cx = Math.floor(pos.x + 0.5)
      const cz = Math.floor(pos.z + 0.5)
      this._chunk.x = Math.floor(cx / CHUNK_WIDTH)
      this._chunk.z = Math.floor(cz / CHUNK_DEPTH)
      this._mod = false
      this._chunk.dirty = false
    }
    return this._chunk
  }

  get chunkId() {
    const chunk = this.chunk
    if (!chunk) return null
    return `${chunk.x}_${chunk.z}`
  }

  get voxelIdx() {
    const chunk = this.chunk
    if (!chunk) return -1
    // const localX = Math.floor(this._world.x + 0.5) - chunk.x * CHUNK_WIDTH
    // const localY = Math.floor(this._world.y)
    // const localZ = Math.floor(this._world.z + 0.5) - chunk.z * CHUNK_DEPTH
    // Derive locals from the same center-rounded integers (no drift at edges)
    const cx = Math.floor(this._world.x + 0.5)
    const cz = Math.floor(this._world.z + 0.5)
    const localX = cx - chunk.x * CHUNK_WIDTH
    const localY = Math.floor(this._world.y)
    const localZ = cz - chunk.z * CHUNK_DEPTH
    return getVoxelIdx(localX, localY, localZ)
  }

  get voxelId() {
    return `${this.voxel.x}_${this.voxel.y}_${this.voxel.z}`
  }

  copy(loc) {
    this._mod = true
    this._world.copy(loc._world)
    this._voxel.copy(loc._voxel)
    this._voxel.dirty = true
    this._chunk.copy(loc._chunk)
    this._chunk.dirty = true
    this._mod = false
    return this
  }

  get north() {
    const loc = locationPool.get().copy(this)
    loc.voxel.z -= 1
    return loc
  }

  get east() {
    const loc = locationPool.get().copy(this)
    loc.voxel.x += 1
    return loc
  }

  get south() {
    const loc = locationPool.get().copy(this)
    loc.voxel.z += 1
    return loc
  }

  get west() {
    const loc = locationPool.get().copy(this)
    loc.voxel.x -= 1
    return loc
  }

  get up() {
    const loc = locationPool.get().copy(this)
    loc.voxel.y += 1
    return loc
  }

  get down() {
    const loc = locationPool.get().copy(this)
    loc.voxel.y -= 1
    return loc
  }
}

globalThis.Location = Location

class LocationPool {
  constructor(size = 256) {
    this.pool = Array.from({ length: size }, () => new Location())
    this.index = 0
    this.size = size
  }

  get() {
    const loc = this.pool[this.index] || (this.pool[this.index] = new Location())
    this.index = (this.index + 1) % this.size
    return loc
  }

  clear() {
    this.index = 0
  }
}

export const locationPool = new LocationPool()
